import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f3e665a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "contact" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-center mb-4" }, "Kontaktiere uns", -1))
const _hoisted_4 = { class: "row justify-content-center" }
const _hoisted_5 = { class: "col-md-8" }
const _hoisted_6 = { class: "card" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form-label"
}, "Name", -1))
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "form-label"
}, "E-Mail", -1))
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "message",
  class: "form-label"
}, "Nachricht", -1))
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-6" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "col-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("form", null, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "name",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.name) = $event))
                  }, null, 512), [
                    [_vModelText, $setup.form.name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    class: "form-control",
                    id: "email",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.email) = $event))
                  }, null, 512), [
                    [_vModelText, $setup.form.email]
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _withDirectives(_createElementVNode("textarea", {
                    class: "form-control",
                    id: "message",
                    rows: "3",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.message) = $event))
                  }, null, 512), [
                    [_vModelText, $setup.form.message]
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("button", {
                      type: "submit",
                      class: "btn btn-primary",
                      disabled: $setup.buttonDisable,
                      style: {"background-color":"var(--cta-color)"},
                      onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submitForm && $setup.submitForm(...args)), ["prevent"]))
                    }, " Absenden ", 8, _hoisted_16)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("p", null, _toDisplayString($setup.response_message), 1)
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}